import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalService } from '../../modal/modal.service';
import { NotificationService } from '../../notification/notification.service';
import { ChatService } from '@features/chat/chat.service';
import { ModalBoxComponent } from '@shared/modal-box/modal-box.component';

@Component({
  selector: 'app-start-rain-trivia-modal',
  templateUrl: './start-rain-trivia-modal.component.html',
  styleUrls: ['./start-rain-trivia-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ModalBoxComponent, FormsModule, ReactiveFormsModule],
})
export class StartRainTriviaModalComponent {
  triviaRainForm = new FormGroup({
    amount: new FormControl(undefined, [Validators.required, Validators.min(1)]),
    triviaQuestion: new FormControl('', [Validators.required, Validators.minLength(3)]),
    triviaAnswer: new FormControl('', [Validators.required]),
    triviaIncorrect1: new FormControl('', [Validators.required, Validators.minLength(2)]),
    triviaIncorrect2: new FormControl('', [Validators.required, Validators.minLength(2)]),
    triviaIncorrect3: new FormControl('', [Validators.required, Validators.minLength(2)]),
  });

  constructor(private chatService: ChatService, private notificationsService: NotificationService, private modalService: ModalService) {}

  async startTriviaRain() {
    const errors = [];
    if (this.triviaRainForm.controls['triviaQuestion'].errors) {
      errors.push('Question must be at least 3 characters long');
    }

    if (
      this.triviaRainForm.controls['triviaAnswer'].errors ||
      this.triviaRainForm.controls['triviaIncorrect1'].errors ||
      this.triviaRainForm.controls['triviaIncorrect2'].errors ||
      this.triviaRainForm.controls['triviaIncorrect3'].errors
    ) {
      errors.push('You must have 4 possible answers');
    }

    if (this.triviaRainForm.controls['amount'].errors) {
      errors.push('Amount must be at least 1');
    }

    if (this.triviaRainForm.invalid) {
      this.notificationsService.error(errors.join('. '), 'ERROR');

      return;
    }

    await this.chatService.startTriviaRain(
      this.triviaRainForm.value.triviaQuestion,
      this.triviaRainForm.value.triviaAnswer,
      [this.triviaRainForm.value.triviaIncorrect1, this.triviaRainForm.value.triviaIncorrect2, this.triviaRainForm.value.triviaIncorrect3],
      this.triviaRainForm.value.amount,
    );
    this.modalService.close();
  }
}
